type BeaconQueueEntry = {method: string; options: unknown; data: unknown};
type BeaconStub = ((method: string, options?: unknown, data?: unknown) => void) & {
  readyQueue: BeaconQueueEntry[];
};

declare global {
  interface Window {
    Beacon?: BeaconStub;
  }
}

const BEACON_SRC = 'https://beacon-v2.helpscout.net';

function injectBeaconScript() {
  const firstScript = document.getElementsByTagName('script')[0];
  if (!firstScript || !firstScript.parentNode) {
    document.head.appendChild(buildScript());
    return;
  }
  firstScript.parentNode.insertBefore(buildScript(), firstScript);
}

function buildScript(): HTMLScriptElement {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = BEACON_SRC;
  return script;
}

export function initBeacon() {
  if (window.Beacon && window.Beacon.readyQueue) {
    return;
  }

  const queue: BeaconQueueEntry[] = [];
  const stub = ((method: string, options?: unknown, data?: unknown) => {
    queue.push({method, options, data});
  }) as BeaconStub;
  stub.readyQueue = queue;
  window.Beacon = stub;

  if (document.readyState === 'complete') {
    injectBeaconScript();
  } else {
    window.addEventListener('load', injectBeaconScript, false);
  }
}
